// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"0c960da6","614":"84f7c55c"}[chunkId] + ".chunk.css";
};